import React, { useCallback, useEffect, useRef, useState } from 'react';
// import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import * as Yup from 'yup';

import { ReactComponent as CleanIcon } from '../../../../assets/icons/ubr_clean.svg';
import {
  ReactComponent as Download,
  ReactComponent as DownloadIcon,
} from '../../../../assets/icons/ubr_download.svg';
import { ReactComponent as FilterIcon } from '../../../../assets/icons/ubr_filter.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/ubr_search.svg';
import {
  Button,
  Input,
  Modal,
  Pagination,
  Select,
  Shimmer,
} from '../../../../components';
import Accordion from '../../../../components/Accordion';
import api from '../../../../services/api';
import { EndpointsAPI } from '../../../../services/Endpoints';
import checkValidIntervalDate from '../../../../utils/checkValidIntervalDate';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { hash } from '../../../../utils/hashGenerator';
import { periodo } from './periodo';
import {
  ActionsForm,
  Badge,
  Container,
  FooterTable,
  InputGroup,
  List,
  LoadingData,
  OrderContainer,
  TableContainer,
} from './styles';

interface SearchProps {
  cooperativa?: string | undefined;
  agencia?: string;
  conta?: string;
  periodo?: string | undefined;
  dataFim?: string;
  dataInicio?: string;
}

export enum StatusType {
  Default = 'DEFAULT',
  Pendente = 'PENDENTE',
  Processando = 'PROCESSANDO',
  Sucesso = 'SUCESSO',
  Erro = 'ERRO',
}

interface DataProps {
  agencia: string;
  conta: string;
  cooperativa: string;
  dataOperacao: string;
  processoCobrancaDTO: {
    idProcesso: string;
    mensagemProcesso: string;
    status: StatusType;
    leitorCnab: {
      idArquivoMotor: string;
      status: StatusType;
      dataCriacao: string;
      motorEnum: string;
      nomeArquivoOriginal: string;
      nomeRepositorio: string;
    };
    motorCnab: {
      idArquivoMotor: string;
      status: StatusType;
      dataCriacao: string;
      motorEnum: string;
    };
    leitorPdf: [
      {
        idArquivoMotor: string;
        status: StatusType;
        dataCriacao: string;
        motorEnum: string;
      },
    ];
    motorPdf: [
      {
        idArquivoMotor: string;
        status: StatusType;
        dataCriacao: string;
        motorEnum: string;
      },
    ];
    motorCnabPdf: {
      idArquivoMotor: string;
      status: StatusType;
      dataCriacao: string;
      motorEnum: string;
    };
    motorHomologacao: string;
  };
  tipoCnab: string;
}

const RelatorioAnalitico: React.FC = () => {
  const [data, setData] = useState<DataProps | any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [itemsPerPage, setitemsPerPage] = useState<number>(5);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [order, setOrder] = useState<boolean>();
  const [filter, setFilter] = useState<{
    cooperativa: string | null;
    agencia: string | null;
    conta: string | null;
    dataInicio: string | null;
    dataFim: string | null;
    periodo: number | string | null;
    paginacao: {
      direcao: string;
      numeroPagina: number;
      tamanhoPagina: number;
    };
    produto: string;
  }>({
    cooperativa: data.cooperativa ? data.cooperativa : null,
    agencia: data.agencia ? data.agencia : null,
    conta: data.conta ? data.conta : null,
    dataInicio: data.dataInicio ? data.dataInicio : null,
    dataFim: data.dataFim ? data.dataFim : null,
    periodo: data.periodo ? data.periodo : null,
    paginacao: {
      direcao: !order ? 'ASC' : 'DESC',
      numeroPagina: currentPage,
      tamanhoPagina: itemsPerPage,
    },
    produto: 'COBRANCA',
  });
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [showErrorPDFModal, setShowErrorPDFModal] = useState<boolean>(false);
  const [showErrorCNABxPDFModal, setShowErrorCNABxPDFModal] = useState<boolean>(
    false,
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [idError, setIdError] = useState<string>();
  const [dataError, setDataError] = useState<[]>([]);
  const formRef = useRef<FormHandles | null>(null);
  let selectedPeriodo = useRef<any>();

  const showModalError = (id: string) => {
    setShowErrorModal(true);
    setIdError(id);
    fetchError(id);
  };

  const showModalErrorPDF = (id: string) => {
    setShowErrorPDFModal(true);
    setIdError(id);
    fetchError(id);
  };

  const showModalErrorCNABxPDF = (id: string) => {
    setShowErrorCNABxPDFModal(true);
    setIdError(id);
    fetchError(id);
  };

  const fetchError = useCallback(async (id: string) => {
    const { data } = await api.get(
      EndpointsAPI.motorCobranca + `/${id}/criticas`,
    );
    setDataError(data);
  }, []);

  const fetchData = useCallback(
    async (search: any) => {
      formRef.current?.setErrors({});
      setIsLoading(true);

      try {
        const response = await api.post('/relatorios/analitico', search);
        setData(response.data);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    },
    [filter, itemsPerPage, currentPage, order],
  );

  function formatDate(data: string) {
    if (!data) {
      return 'N/D';
    }
    let dateLocal = new Date(data);
    return (
      dateLocal.toLocaleDateString() + ' ' + dateLocal.toLocaleTimeString()
    );
  }

  // Download dos arquivos

  const handleDownloadFiles = async (idProcesso: string) => {
    const response = await api.get(
      EndpointsAPI.baixarPorIdProcessoCobranca + `/${idProcesso}/download`,
      {
        responseType: 'arraybuffer',
      },
    );

    const url = URL.createObjectURL(
      new Blob([response?.data], {
        type: 'blob',
      }),
    );
    FileSaver.saveAs(url, `${idProcesso}.rar`);
  };

  // Renderizar a tabela

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>

        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
      </tr>
    );
  };

  const renderData = () => {
    let tmpItem: StatusType = StatusType.Default;

    return (
      <TableContainer>
        <table id="tableData">
          <thead>
            <tr>
              <th style={{ width: '100px' }}>
                <OrderContainer>
                  Cooperativa
                  {/* {order ? (
                    <button onClick={() => setOrder(false)}>
                      <AiOutlineArrowUp />
                    </button>
                  ) : (
                    <button onClick={() => setOrder(true)}>
                      <AiOutlineArrowDown />
                    </button>
                  )} */}
                </OrderContainer>
              </th>
              <th style={{ width: '100px' }}>Agência</th>
              <th style={{ width: '100px' }}>Conta</th>

              <th style={{ width: '160px' }}>Data da Operação</th>
              <th style={{ width: '260px' }}>Validação</th>
              <th style={{ width: '160px' }}>Tipo CNAB</th>
              <th style={{ width: '100px' }}>Ações</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              {loadingTable()}
              {loadingTable()}
              {loadingTable()}
            </tbody>
          ) : !data.content!?.length ? (
            <LoadingData> Sem dados para exibir... </LoadingData>
          ) : (
            <tbody>
              {data!?.content!?.map((todo: DataProps, index: number) => {
                return (
                  <tr key={index}>
                    <td data-column="Cooperativa">{todo.cooperativa}</td>
                    <td data-column="Agência">{todo.agencia}</td>
                    <td data-column="Conta">{todo.conta}</td>

                    <td data-column="Data da Operação">
                      {formatDate(todo.dataOperacao)}
                    </td>
                    <td data-column="Validação">
                      <div>
                        <Badge
                          type={
                            todo.processoCobrancaDTO.motorCnab
                              ? todo.processoCobrancaDTO.motorCnab.status
                              : StatusType.Default ||
                                todo.processoCobrancaDTO.leitorCnab
                              ? todo.processoCobrancaDTO.leitorCnab.status
                              : StatusType.Default
                          }
                          onClick={
                            todo.processoCobrancaDTO.leitorCnab.status ===
                            StatusType.Erro
                              ? () =>
                                  showModalError(
                                    todo.processoCobrancaDTO.leitorCnab
                                      .idArquivoMotor,
                                  )
                              : todo.processoCobrancaDTO.motorCnab!?.status ===
                                StatusType.Erro
                              ? () =>
                                  showModalError(
                                    todo.processoCobrancaDTO.motorCnab
                                      .idArquivoMotor,
                                  )
                              : () => {}
                          }
                        >
                          CNAB
                        </Badge>
                        {todo.processoCobrancaDTO.leitorPdf.length >= 1 && (
                          <>
                            {todo.processoCobrancaDTO.leitorPdf.map(data => {
                              if (data.status === StatusType.Erro) {
                                tmpItem = StatusType.Erro;
                              } else if (data.status === StatusType.Sucesso) {
                                tmpItem = StatusType.Sucesso;
                              } else if (data.status === StatusType.Pendente) {
                                tmpItem = StatusType.Pendente;
                              } else if (
                                data.status === StatusType.Processando
                              ) {
                                tmpItem = StatusType.Processando;
                              } else {
                                tmpItem = StatusType.Default;
                              }

                              return true;
                            })}
                          </>
                        )}
                        {todo.processoCobrancaDTO.motorPdf.length >= 1 && (
                          <>
                            {todo.processoCobrancaDTO.motorPdf.map(data => {
                              if (data.status === StatusType.Erro) {
                                tmpItem = StatusType.Erro;
                              } else if (data.status === StatusType.Sucesso) {
                                tmpItem = StatusType.Sucesso;
                              } else if (data.status === StatusType.Pendente) {
                                tmpItem = StatusType.Pendente;
                              } else if (
                                data.status === StatusType.Processando
                              ) {
                                tmpItem = StatusType.Processando;
                              } else {
                                tmpItem = StatusType.Default;
                              }

                              return true;
                            })}
                          </>
                        )}

                        <Badge
                          type={
                            (todo.processoCobrancaDTO.leitorPdf.length &&
                              tmpItem) ||
                            (todo.processoCobrancaDTO.motorPdf.length &&
                              tmpItem)
                          }
                          onClick={() =>
                            todo.processoCobrancaDTO.leitorPdf.length &&
                            todo.processoCobrancaDTO.leitorPdf[0].status ===
                              StatusType.Erro
                              ? todo.processoCobrancaDTO.leitorPdf.map(data => {
                                  return showModalErrorPDF(data.idArquivoMotor);
                                })
                              : todo.processoCobrancaDTO.motorPdf.length &&
                                todo.processoCobrancaDTO.motorPdf[0].status ===
                                  StatusType.Erro
                              ? todo.processoCobrancaDTO.motorPdf.map(data => {
                                  return showModalErrorPDF(data.idArquivoMotor);
                                })
                              : () => {}
                          }
                        >
                          PDF
                        </Badge>

                        <Badge
                          type={
                            todo.processoCobrancaDTO.motorCnabPdf
                              ? todo.processoCobrancaDTO.motorCnabPdf.status
                              : StatusType.Default
                          }
                          onClick={
                            todo.processoCobrancaDTO.motorCnabPdf?.status ===
                            StatusType.Erro
                              ? () =>
                                  showModalErrorCNABxPDF(
                                    todo.processoCobrancaDTO.motorCnabPdf
                                      ?.idArquivoMotor,
                                  )
                              : () => {}
                          }
                        >
                          CNAB x PDF
                        </Badge>
                      </div>
                    </td>
                    <td data-column="Tipo CNAB">
                      {todo.tipoCnab ? todo.tipoCnab : <div>NÃO INFORMADO</div>}
                    </td>

                    <td data-column="Ações">
                      <div>
                        <Button
                          variant="solid-icon"
                          onClick={() =>
                            setTimeout(() => {
                              handleDownloadFiles(
                                todo.processoCobrancaDTO.idProcesso,
                              );
                            }, 500)
                          }
                          tooltipText={'Download dos Arquivos'}
                        >
                          <Download style={{ width: '20px' }} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </TableContainer>
    );
  };

  const today = moment(new Date()).format('YYYY-MM-DD');

  const handleFilter = useCallback(
    async (data: SearchProps) => {
      data.periodo = selectedPeriodo.current;

      if ((data.dataInicio || data.dataFim) && !data.cooperativa) {
        data.cooperativa = null as any;
      }
      try {
        formRef.current?.setErrors({});
        if (data.dataInicio! > today) {
          const schema = Yup.object().shape({
            dataInicio: Yup.number().typeError(
              'Data de início não pode ser maior que hoje',
            ),
          });

          await schema.validate(data, {
            abortEarly: false,
          });
        }
        if (data.dataFim! > today) {
          const schema = Yup.object().shape({
            dataFim: Yup.number().typeError(
              'Data de fim não pode ser maior que hoje',
            ),
          });

          await schema.validate(data, {
            abortEarly: false,
          });
        }

        if (!data.periodo) {
          if (!checkValidIntervalDate(data.dataInicio!, data.dataFim!)) {
            const schema = Yup.object().shape({
              dataInicio: Yup.number().typeError(
                'Data de Inicio deve ser menor que Data Final',
              ),
            });
            const select = formRef!.current!.getFieldRef('periodo');
            select.select.clearValue();
            await schema.validate(data, {
              abortEarly: false,
            });
          }
        }
        if (data.dataInicio || data.dataFim) {
          const schema = Yup.object().shape({
            dataInicio: Yup.string().required('Este campo é obrigatório!'),
            dataFim: Yup.string().required('Este campo é obrigatório!'),
          });
          const select = formRef!.current!.getFieldRef('periodo');
          select.select.clearValue();
          await schema.validate(data, {
            abortEarly: false,
          });
        }

        setFilter({
          cooperativa: data.cooperativa ? data.cooperativa : null,
          agencia: data.agencia ? data.agencia : null,
          conta: data.conta ? data.conta : null,
          dataInicio: data.dataInicio ? data.dataInicio : null,
          dataFim: data.dataFim ? data.dataFim : null,
          periodo: data.periodo ? data.periodo : null,
          paginacao: {
            direcao: !order ? 'ASC' : 'DESC',
            numeroPagina: currentPage,
            tamanhoPagina: itemsPerPage,
          },
          produto: 'COBRANCA',
        });

        if ((data.dataInicio || data.dataFim) && data.periodo) {
          const select = formRef!.current!.getFieldRef('periodo');
          select.select.clearValue();
        } else {
          fetchData({
            cooperativa: data.cooperativa ? data.cooperativa : null,
            agencia: data.agencia ? data.agencia : null,
            conta: data.conta ? data.conta : null,
            dataInicio: data.dataInicio ? data.dataInicio : null,
            dataFim: data.dataFim ? data.dataFim : null,
            periodo: data.periodo ? data.periodo : null,
            paginacao: {
              direcao: !order ? 'ASC' : 'DESC',
              numeroPagina: currentPage,
              tamanhoPagina: itemsPerPage,
            },
            produto: 'COBRANCA',
          });
          setIsLoading(false);
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errorMessages = getValidationErrors(err);
          formRef.current?.setErrors(errorMessages);
          return;
        }
      }
    },
    [filter],
  );

  const onClear = () => {
    formRef.current?.reset();
    formRef.current?.setErrors({});

    const select = formRef!.current!.getFieldRef('periodo');
    select.select.clearValue();
    fetchData({
      cooperativa: null,
      agencia: null,
      conta: null,
      dataInicio: null,
      dataFim: null,
      periodo: null,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: 0,
        tamanhoPagina: itemsPerPage,
      },
      produto: 'COBRANCA',
    });
  };

  const relatoryDownload = async () => {
    const response = await api.post('/relatorios/analitico/criticas', filter, {
      responseType: 'arraybuffer',
    });

    const url = URL.createObjectURL(
      new Blob(['\ufeff', response.data], {
        type: 'text/csv;charset=utf-8',
      }),
    );

    FileSaver.saveAs(
      url,
      'relatório-analítico_' + new Date().getTime() + '.csv',
    );
  };

  useEffect(() => {
    fetchData({
      ...filter,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: currentPage,
        tamanhoPagina: itemsPerPage,
      },
    });
  }, [currentPage, itemsPerPage, order]);

  return (
    <>
      <Modal
        show={showErrorModal || showErrorPDFModal || showErrorCNABxPDFModal}
        titulo={
          showErrorModal
            ? 'Erro no arquivo CNAB enviado'
            : showErrorPDFModal
            ? 'Erro no(s) PDF(s) enviados'
            : showErrorCNABxPDFModal
            ? 'Erro ao comparar CNAB e PDF'
            : ''
        }
        mensagem={`Você deve verificar os erros, corrigi-los e tentar novamente.`}
        onCancel={() => {
          showErrorModal && setShowErrorModal(false);
          showErrorPDFModal && setShowErrorPDFModal(false);
          showErrorCNABxPDFModal && setShowErrorCNABxPDFModal(false);
          setDataError([]);
        }}
        onConfirm={() => {}}
      >
        {(dataError.length && showErrorModal) ||
        (dataError.length && showErrorPDFModal) ? (
          dataError.map((data: any, index: number) => {
            return (
              <>
                <List>
                  <div className="list-content-secondary">
                    <span>
                      <b> ERRO ENCONTRADO: </b>
                    </span>
                    {data.mensagem}
                  </div>

                  {showErrorPDFModal && (
                    <li>
                      <b className="list-content-principal">
                        DETALHES DE ERRO:{' '}
                      </b>
                      <>Linha: {data.linha}</>
                    </li>
                  )}

                  <li>
                    {showErrorModal && (
                      <b className="list-content-principal">
                        DETALHES DO ERRO:{' '}
                      </b>
                    )}
                    {showErrorPDFModal && (
                      <b className="list-content-principal">POSIÇÕES: </b>
                    )}

                    <>
                      {showErrorModal && <>Linha: {data.posicaoLinha}</>}{' '}
                      Posição Inicial: {data.posicaoInicial}, Posição Final:{' '}
                      {data.posicaoFinal}
                    </>
                  </li>
                  {data.valorEsperado === null ||
                  data.valorEsperado === undefined ||
                  data.valorEsperado === '' ||
                  data.valorEsperado === 'SEM VALOR ESPERADO' ? null : (
                    <li>
                      <b className="list-content-principal">VALOR ESPERADO: </b>
                      {data.valorEsperado}
                    </li>
                  )}
                  <li>
                    <b className="list-content-principal">VALOR INFORMADO: </b>
                    {data.valor}
                  </li>
                  <Accordion
                    id={hash(index)}
                    key={index}
                    title="Mais Informações"
                    description={
                      <>
                        <li>
                          <b>Campo: </b>
                          {data.chave}
                        </li>
                        <li>
                          <b>Tipo de segmento: </b>
                          {data.tipoValidacaoModelo}
                        </li>

                        <li>
                          <b>Tipo de validação: </b>
                          {data.validacaoCritica}
                        </li>
                      </>
                    }
                  />
                </List>
              </>
            );
          })
        ) : dataError.length && showErrorCNABxPDFModal ? (
          dataError.map((data: any, index: number) => {
            return (
              <>
                <List>
                  <div className="list-content-secondary">
                    <span>
                      <b> ERRO ENCONTRADO: </b>
                    </span>
                    {data.mensagem}
                  </div>

                  <li>
                    <b className="list-content-principal">DETALHES DE ERRO: </b>
                    <>
                      Linha: <b>{data.linha}</b>
                    </>
                  </li>
                  {data.valorEsperado === null ||
                  data.valorEsperado === undefined ||
                  data.valorEsperado === '' ||
                  data.valorEsperado === 'SEM VALOR ESPERADO' ? null : (
                    <li>
                      <b className="list-content-principal">
                        VALOR ESPERADO DO CNAB:{' '}
                      </b>
                      {data.valorEsperado}
                    </li>
                  )}
                  <li>
                    <b className="list-content-principal">
                      VALOR INFORMADO DO PDF:{' '}
                    </b>
                    {data.valor}
                  </li>
                  <Accordion
                    id={hash(index)}
                    key={index}
                    title="Mais Informações"
                    description={
                      <>
                        <li>
                          <b>Campo: </b>
                          {data.chave}
                        </li>
                        <li>
                          <b>Tipo de segmento: </b>
                          {data.tipoValidacaoModelo}
                        </li>

                        <li>
                          <b>Tipo de validação: </b>
                          {data.validacaoCritica}
                        </li>
                      </>
                    }
                  />
                </List>
              </>
            );
          })
        ) : (
          <>
            <div style={{ marginTop: '2rem' }}>
              <Shimmer height={'25px'} />
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ marginTop: '1rem' }}>
                <Shimmer height={'25px'} />
              </div>
            </div>
          </>
        )}
      </Modal>
      <Container>
        <Form className="form-container" ref={formRef} onSubmit={handleFilter}>
          <FilterIcon width={28} />
          <InputGroup>
            <Input
              name="cooperativa"
              label="Cooperativa"
              type="text"
              mask={'coop'}
              placeholder="0000"
              disableMargin={true}
            />
            <Input
              name="agencia"
              label="Agencia"
              type="text"
              mask={'agencia'}
              placeholder="0000"
              disableMargin={true}
            />
            <Input
              name="conta"
              label="Conta"
              type="text"
              mask={'conta'}
              placeholder="000000"
              disableMargin={true}
            />
            <Input
              name="dataInicio"
              label="Data Inicio"
              type="date"
              max={today}
              placeholder="Date"
              disableMargin={true}
            />
            <Input
              name="dataFim"
              label="Data Fim"
              type="date"
              max={today}
              placeholder="Date"
              disableMargin={true}
            />

            <div className="select-field">
              <Select
                name={'periodo'}
                isMulti={false}
                options={periodo}
                initialValues={"30"}
                onChange={option => (selectedPeriodo.current = option.value)}
                placeholder="Selecione"
                label="Período"
              />
            </div>
          </InputGroup>
          <ActionsForm>
            <div>
              <Button
                variant="solid-icon"
                type={'submit'}
                style={{ marginRight: '1rem' }}
                tooltipText={'Pesquisar'}
              >
                <SearchIcon style={{ width: '26px' }} />
              </Button>
              <Button
                variant="solid-icon"
                type={'reset'}
                onClick={onClear}
                tooltipText={'Limpar Campos'}
              >
                <CleanIcon style={{ width: '26px' }} />
              </Button>
            </div>
            <Button
              onClick={() => relatoryDownload()}
              variant={'solid-icon'}
              tooltipText={'Baixar Relatório'}
              style={{ width: '24px' }}
            >
              <DownloadIcon />
            </Button>
          </ActionsForm>
        </Form>
        {renderData()}
        <FooterTable>
          <Pagination
            pageCount={data.totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={data.size}
            forcePage={currentPage}
            onPageChange={(pageNumber: any) => {
              setCurrentPage(pageNumber.selected);
            }}
            onPageSize={(pageSize: any) => {
              setCurrentPage(0);
              setitemsPerPage(pageSize.value);
            }}
          />
        </FooterTable>
      </Container>
    </>
  );
};

export default RelatorioAnalitico;
